var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404PageLayoutMobileDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 45,
    viewBox: "0 0 375 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M375.301 21.5594V38.4262L0.0751343 38.4262V20.7465L2.26358 19.96C27.8856 10.7521 55.7263 9.68256 81.9791 16.8977L95.3994 20.5861C115.515 26.1145 136.91 24.6644 156.096 16.4724C177.785 7.21117 202.197 6.60518 224.32 14.7788L228.259 16.2343C247.338 23.2836 268.079 24.5169 287.859 19.7781L332.09 9.18175C347.668 5.44992 364.062 10.146 375.301 21.5594Z",
    fill: "#6F6DE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M375.301 26.6531V38.4271L0.0751343 38.4271V20.341C10.3796 9.21395 26.2596 5.17912 40.6258 10.0378L58.6914 16.1476C74.2401 21.4063 91.1674 20.8547 106.341 14.595L110.793 12.7584C127.601 5.82418 146.258 4.76602 163.743 9.75525L199.266 19.8914C220.035 25.8178 242.243 24.0705 261.83 14.969C282.503 5.363 306.052 3.96714 327.715 11.0638L375.301 26.6531Z",
    fill: "#6F6DE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.3592L0 45.1332L375.301 45.1332V35.3563C354.211 23.2048 329.21 19.7717 305.625 25.7888L294.212 28.7006C276.178 33.3016 257.093 31.2922 240.413 23.0365C221.938 13.8925 200.592 12.446 181.053 19.014L162.775 25.1578C144.24 31.3884 124.146 31.1939 105.734 24.6057C90.7416 19.241 74.5644 18.0931 58.9646 21.2869L0 33.3592Z",
    fill: "#6F6DE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404PageLayoutMobileDark);
export default __webpack_public_path__ + "static/media/404-page-layout-mobile-dark.652a5ed6f4bb36e6afc40b8c3a988f54.svg";
export { ForwardRef as ReactComponent };